import A11yDialog from 'a11y-dialog';
const $ = jQuery;

export default function loginModal() {
  // Get the dialog element
  const el = $( '#login-modal' )[0];

  if ( ! el ) {
    return;
  }

  // Instantiate a new A11yDialog module
  const dialog = new A11yDialog( el );

  $( '.my-account-menu .welcome a' ).on( 'click', function( e ) {
    e.preventDefault();
    dialog.show();
  });


  dialog.on( 'show', function(e) {

    $( '#user_login' ).attr( {
      required: true,
      placeholder: 'Email Address',
    });

    $( '#user_pass' ).attr( {
      required: true,
      placeholder: 'Password',
    });

    $('#user_login').focus();

    // $( '<span class="checkbox-custom"></span>' ).insertAfter( '#rememberme');
  });

  if ( window.location.search.includes('?login=failed') ) {
    dialog.show();
  } else if ( window.location.search.includes('?registered=success') ) {
    dialog.show();
    showRegistrationForm();
  } else if ( window.location.search.includes('?registered=failed' ) ) {
    dialog.show();
    showRegistrationForm();
  }

  $('.modal-new-account').click(function(e){
    e.preventDefault();
    showRegistrationForm();
  });

  $('.modal-go-back').click(function(e) {
    e.preventDefault();
    showSigninForm();
  });

  function showSigninForm() {
    $( '.modal-content__register' ).hide();
    $( '.modal-content__sign-in' ).show();

    $( '#user_login' ).focus();
  }

  function showRegistrationForm() {
    $( '.modal-content__register' ).show();
    $( '.modal-content__sign-in' ).hide();

    $( '#user_login_register' ).focus();
  }
}
